import React from "react";

const MyPaylink = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <header className="fixed w-full bg-gray-900 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <a href="/" className="flex items-center">
              <div className="bg-blue-600 text-white w-10 h-10 rounded-lg flex items-center justify-center font-bold text-xl">
                UPI
              </div>
              <span className="ml-3 text-xl font-bold">MyUPILink</span>
            </a>
            
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#learn" className="text-white hover:text-blue-400 transition duration-300">
                Learn to use
              </a>
              <a 
                href="/create-upi" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full transition duration-300 shadow-lg hover:shadow-xl"
              >
                Get started
              </a>
            </nav>
            
            <button className="md:hidden text-white">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-gray-900 to-gray-800">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-12 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                Create & request payments <br className="hidden md:block" />
                with links & QR
              </h1>
              <p className="text-gray-400 mb-8 text-lg max-w-lg">
                MyPaylink helps you quickly request UPI payments with shareable links & QR Codes
              </p>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <a 
                  href="/create-upi" 
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full text-center transition duration-300 shadow-lg hover:shadow-xl"
                >
                  Create your link ⚡
                </a>
                <a 
                  href="#learn" 
                  className="bg-gray-700 hover:bg-gray-600 text-white px-8 py-3 rounded-full text-center transition duration-300"
                >
                  Learn to use
                </a>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img 
                src="https://i.ibb.co/x8Pgc7V8/mainheader.webp" 
                alt="Hero" 
                className="rounded-xl shadow-2xl w-full max-w-md object-cover" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Logo Strip */}
      <div className="bg-gray-400 py-8 overflow-hidden">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            <img src="https://i.ibb.co/Wp3rvsLK/Google-Pay-Logo.png" alt="Google Pay" className="h-8" />
            <div className="h-8 w-px bg-gray-600"></div>
            <img src="https://i.ibb.co/gbNP1F0G/bhim.png" alt="Bhim" className="h-8" />
            <div className="h-8 w-px bg-gray-600"></div>
            <img src="https://i.ibb.co/MyhvH3XC/phonepe.webp" alt="PhonePe" className="h-8" />
            <div className="h-8 w-px bg-gray-600"></div>
            <img src="https://i.ibb.co/KxWgjNr6/amazon.png" alt="Amazon Pay" className="h-8" />
            <div className="h-8 w-px bg-gray-600"></div>
            <img src="https://i.ibb.co/nNcQCXnw/bharatpe.png" alt="BharatPe" className="h-8" />
            <div className="h-8 w-px bg-gray-600"></div>
            <img src="https://i.ibb.co/G3c0ZGFC/tata.png" alt="Tata Neu" className="h-8" />
            <div className="h-8 w-px bg-gray-600"></div>
            <img src="https://i.ibb.co/GQ7DzmTr/WhatsApp.png" alt="WhatsApp" className="h-8" />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section className="py-20 px-6 bg-gray-900">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Fully featured generator for hassle-free UPI payments
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Create payment links in seconds and share them anywhere
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gray-800 p-8 rounded-xl hover:transform hover:scale-105 transition duration-300">
              <div className="w-12 h-12 mb-4 bg-blue-600 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Real-time</h3>
              <p className="text-gray-400">
                Creates UPI payment links and QR Code instantly with no latency and is shareable within seconds.
              </p>
            </div>
            
            <div className="bg-gray-800 p-8 rounded-xl hover:transform hover:scale-105 transition duration-300">
              <div className="w-12 h-12 mb-4 bg-blue-600 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Completely Free</h3>
              <p className="text-gray-400">
                No charges to create or share our links. No hidden fees or subscriptions.
              </p>
            </div>
            
            <div className="bg-gray-800 p-8 rounded-xl hover:transform hover:scale-105 transition duration-300">
              <div className="w-12 h-12 mb-4 bg-blue-600 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Secure</h3>
              <p className="text-gray-400">
                End-to-End encrypted so your data remains safe and private.
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <a 
              href="/create-upi" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full inline-block transition duration-300 shadow-lg hover:shadow-xl"
            >
              Generate your link ⚡
            </a>
          </div>
        </div>
      </section>

      {/* How to Use Section */}
      <section id="learn" className="py-20 px-6 bg-gray-800">
        <div className="container mx-auto">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 mb-12 lg:mb-0 lg:pr-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
                How it works?
              </h2>
              <p className="text-gray-300 mb-8 text-lg">
                Easily request UPI payments by following these simple steps
              </p>
              <ul className="space-y-4 text-gray-400 list-disc list-inside">
              <li>Enter the recipient's UPI ID and amount</li>
              <li>Click generate to copy a link instantly</li>
              <li>Share the link or QR via any medium</li>
              <li>Receiver clicks and pays via their preferred app</li>
            </ul>
            <a href="/create-upi" className="mt-6 inline-block bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-full text-white transition">
              Generate now 💸
            </a>
            </div>
            
            <div className="lg:w-3/5 space-y-8">
              <div className="bg-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-[1.02] transition duration-300">
                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-4">1. Enter requesting amount</h3>
                  <p className="text-gray-400 mb-6">
                    Enter the amount you want to request from the payee. You can also add a note explaining the purpose.
                  </p>
                </div>
                <img 
                  src="https://i.ibb.co/QvysGM1m/step1.png" 
                  alt="Step 1" 
                  className="w-full h-auto object-cover" 
                />
              </div>
              
              <div className="bg-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-[1.02] transition duration-300">
                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-4">2. Share the UPI link or QR Code</h3>
                  <p className="text-gray-400 mb-6">
                    A shareable link and QR code will be generated. Send it via WhatsApp, SMS, email or any messaging app.
                  </p>
                </div>
                <img 
                  src="https://i.ibb.co/xqp6bK7d/step2.png" 
                  alt="Step 2" 
                  className="w-full h-auto object-cover" 
                />
              </div>
              
              <div className="bg-gray-900 rounded-xl overflow-hidden hover:transform hover:scale-[1.02] transition duration-300">
                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-4">3. Recipient pays with one click</h3>
                  <p className="text-gray-400 mb-6">
                    The recipient clicks the link and pays instantly using any UPI app like PhonePe, Google Pay, PayTM, etc.
                  </p>
                </div>
                <img 
                  src="https://i.ibb.co/C5yy0ffL/step3.png" 
                  alt="Step 3" 
                  className="w-full h-auto object-cover" 
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-gray-700 to-gray-900">
        <div className="container mx-auto max-w-3xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Try the new way of requesting online UPI payments today
          </h2>
          <p className="text-gray-400 mb-8 text-lg">
            Join thousands of users who are simplifying their payment requests
          </p>
          <div className="mt-8">
            <a 
              href="/create-upi" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full inline-block transition duration-300 text-lg shadow-xl hover:shadow-2xl"
            >
              Create your paylink now 💸
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyPaylink;